<div fxLayout="row wrap" fxLayoutGap="15px">
  @for (service of services(); track service.oid) {
    <div class="app-card">
      <div class="row" class="image-description">
        <div fxFlex="20">
          @if (service.jpegPhoto !== '') {
            <img
              src="data:image/png;base64,{{ service.jpegPhoto }}"
              class="serviceImage"
              alt="Image du service" />
          } @else {
            <img
              src="/assets/images/cards/noimage.png"
              class="serviceImage"
              alt="Image vide" />
          }
        </div>
      </div>
      <div class="title-container">
        <div class="title">{{ service.title }}</div>
        <div class="subtitle secondary-text">{{ service.subtitle }}</div>
      </div>

      <div class="row" class="description">
        <div class="serviceDesc" fxFlex="80">
          {{ service.description }}
        </div>
      </div>

      <div class="action" fxLayout="row" fxLayoutAlign="start center">
        <button
          mat-button
          color="accent"
          class="access-btn"
          (click)="openService(service)"
          [ngClass]="{ maintenance: service.maintenance }"
          [ngStyle]="{ opacity: service.maintenance ? 0.2 : 1 }"
          [disabled]="service.maintenance">
          {{ 'GENERAL.ACCESS' | translate }}
        </button>
        @if (service.help !== '') {
          <button
            mat-button
            color="accent"
            (click)="openDocumentation(service.help)">
            <mat-icon mat-list-icon>help_outline</mat-icon>
          </button>
        }
        @if (service.maintenance) {
          <mat-icon
            class="check-icon"
            color="error"
            [matTooltip]="'GENERAL.SERVICEMAINTENACE' | translate"
            matTooltipPosition="above">
            error_outline
          </mat-icon>
        }
      </div>
    </div>
  }
</div>
